import { axisTop } from 'd3-axis';
import { scaleLinear } from 'd3-scale';

const TICKS = [0, 5, 10, 15];

/**
 * Render the "Wind (mps)" header + tick scale above the wind-line column.
 * The scale spans the same X range that render-wind-line.js maps wind speed
 * into: rightmost 1/5 of the temperature axis.
 *
 * @param {import('d3-selection').Selection} container
 * @param {import('../skewt/scales.js').Scales} scales
 * @param {Array} data - sounding payload (used to compute maxWspd / scale range)
 */
export function drawWindAxis(container, scales, data, i18n = {}) {
    const windLabel = i18n.wind || 'Wind (m/s)';
    container.selectAll('.skewt-ext-wind-axis').remove();
    if (!data || data.length === 0) return;

    const valid = data.filter((d) => Number.isFinite(d.wspd) && Number.isFinite(d.press));
    if (valid.length === 0) return;

    const tMax = scales.tMax;
    const tMin = scales.tMin;
    const range = (tMax - tMin) / 5;
    const maxWspd = Math.max(...valid.map((d) => d.wspd));
    if (maxWspd <= 0) return;
    // Skysight: round maxWspd UP to next multiple of 5 to use as the scale's
    // upper bound — so e.g. the "15" tick lands exactly at the chart's right
    // edge instead of overshooting when actual max is 13. Mirrors render-wind-line.js.
    const scaleMax = Math.max(5, Math.ceil(maxWspd / 5) * 5);
    const tMult = scaleMax / range;

    // Map a wind-speed value to its X pixel position (mirrors render-wind-line.js).
    const xOfWspd = (wspd) => scales.x(tMax - range + wspd / tMult);

    const xStart = xOfWspd(0);
    const xEnd = scales.x(tMax);
    const windScale = scaleLinear()
        .domain([0, scaleMax])
        .range([xStart, xEnd]);

    // Show ticks up to scaleMax (which is already rounded UP to next 5).
    const visibleTicks = TICKS.filter((t) => t <= scaleMax);

    const axis = axisTop(windScale)
        .tickValues(visibleTicks)
        .tickSize(5)
        .tickFormat((d) => `${d}`);

    const g = container.append('g')
        .attr('class', 'skewt-ext-wind-axis')
        .attr('transform', 'translate(0, -5)');

    g.call(axis);
    g.selectAll('text').style('font-size', '10px').style('fill', '#666');

    // Header label
    g.append('text')
        .attr('class', 'wind-label')
        .attr('x', (xStart + xEnd) / 2)
        .attr('y', -22)
        .attr('text-anchor', 'middle')
        .attr('font-size', '11px')
        .attr('fill', '#666')
        .text(windLabel);
}
